import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthStore } from '@app/stores/auth.store';
import { ModalComponent } from '@app/ui-components/modal/modal.component';
import { ValidatedCheckboxComponent } from '@app/ui-components/validated-checkbox/validated-checkbox.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import {
  getLegalExpDeteminationFormGroup,
  LegalExpDeteminationFormGroup,
} from './legal-exp-determination-dialog.helper';

@Component({
  selector: 'app-legal-exp-determination-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    ReactiveFormsModule,
    ModalComponent,
    ValidatedCheckboxComponent,
  ],
  templateUrl: './legal-exp-determination-dialog.component.html',
  styleUrl: './legal-exp-determination-dialog.component.scss',
})
export class LegalExpDeterminationDialogComponent {
  protected expDeterminationForm: FormGroup<LegalExpDeteminationFormGroup>;

  protected store = inject(AuthStore);

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
  ) {
    this.expDeterminationForm = getLegalExpDeteminationFormGroup(fb);
  }

  protected handlePrimaryAction() {
    this.expDeterminationForm.markAllAsTouched();
    if (!this.expDeterminationForm.valid) return;

    this.activeModal.close(this.expDeterminationForm.value);
  }

  protected handleSecondaryAction() {
    this.activeModal.dismiss('canceled');
  }
}
